// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import VueTouch from "vue-touch";

Vue.use(VueTouch, {name: 'v-touch'})


Vue.config.productionTip = false

// Register a global custom directive called `v-focus`
Vue.directive('VueTouch', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.VueTouch()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js